module.exports = __webpack_public_path__ + "img/appstore.594b1cf4.png";